.list {
  flex: 1;
  overflow: auto;
}

.clipWrapper {
  position: relative;
}

.waveform {
  padding-top: 16px;
}
